module.exports = __WEBPACK_EXTERNAL_MODULE_27__;


//////////////////
// WEBPACK FOOTER
// external "vue"
// module id = 27
// module chunks = 0